if (!customElements.get('product-info-box')) {
  customElements.define(
    'product-info-box',
    class ProductInfoBox extends HTMLElement {
      connectedCallback() {
        this.updateHeight = this.updateHeight.bind(this);
        this.updateHeight();
        window.addEventListener('resize', this.updateHeight);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateHeight);
      }

      updateHeight() {
        if (!window.matchMedia('(min-width: 1024px)').matches) {
          this.style.height = '';
          return;
        }
        const top = this.getBoundingClientRect().top;
        const viewportAvailable = window.innerHeight - top - 16;
        const galleryAvailable = this.offsetParent ? this.offsetParent.getBoundingClientRect().height - 32 : viewportAvailable;
        this.style.height = `${Math.min(viewportAvailable, galleryAvailable)}px`;
      }
    }
  );
}
